import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'vex-mail-bulk-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="mail-confirm-dialog">
      <div class="mail-confirm-dialog__icon">
        <mat-icon svgIcon="mat:delete"></mat-icon>
      </div>
      <h2 class="mail-confirm-dialog__title">{{ data.title }}</h2>
      <p class="mail-confirm-dialog__message">{{ data.message }}</p>

      <div class="mail-confirm-dialog__actions">
        <button (click)="dialogRef.close(false)" mat-stroked-button type="button">Cancel</button>
        <button (click)="dialogRef.close(true)" color="warn" mat-flat-button type="button">{{ data.confirmText || 'Delete' }}</button>
      </div>
    </div>
  `,
  styles: [`
    .mail-confirm-dialog {
      width: min(420px, 100%);
      padding: 24px;
      text-align: center;
    }

    .mail-confirm-dialog__icon {
      width: 56px;
      height: 56px;
      margin: 0 auto 16px;
      border-radius: 999px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(244, 67, 54, 0.12);
      color: #d32f2f;
    }

    .mail-confirm-dialog__title {
      margin: 0 0 8px;
      font-size: 20px;
      font-weight: 600;
    }

    .mail-confirm-dialog__message {
      margin: 0;
      font-size: 14px;
      color: rgba(15, 23, 42, 0.72);
    }

    .mail-confirm-dialog__actions {
      display: flex;
      justify-content: center;
      gap: 12px;
      margin-top: 22px;
    }
  `]
})
export class MailBulkConfirmDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string; confirmText?: string },
    public dialogRef: MatDialogRef<MailBulkConfirmDialogComponent>
  ) {}
}
